export default __webpack_public_path__ + "static/media/access_control_number.84703262.svg";